import { extendVariants, Tabs as HeroUITabs, Tab } from "@heroui/react";
import { ReactNode } from "react";

export const ExtendedTabs = extendVariants(HeroUITabs, {
  variants: {
    variant: {
      bordered: {
        cursor:
          "group-data-[selected=true]:bg-primary body-lg rounded-md shadow-none",
        tabContent: "body-md",
        tabList: "shadow-none border border-primary rounded-md",
      },
      "no-underline": {
        cursor: "hidden",
        tabContent: "group-data-[selected=true]:text-primary body-lg",
        tabList: "bg-transparent",
      },
      underlined: {
        cursor: "bg-primary shadow-none",
        tabContent: "group-data-[selected=true]:text-primary body-lg",
      },
    },
  },
});

type ExtendedTabsProps = React.ComponentProps<typeof ExtendedTabs>;

type TabsVariant = Extract<
  ExtendedTabsProps["variant"],
  "underlined" | "no-underline" | "bordered"
>;

type Item = {
  key: string;
  title: string | ReactNode;
};

export type TabsProps = Omit<ExtendedTabsProps, "variant" | "items"> & {
  items: Item[];
  variant: TabsVariant;
};

export const Tabs = ({ items, ...props }: TabsProps) => {
  return (
    <ExtendedTabs
      classNames={{
        tabContent:
          "group-data-[selected=true]:font-semibold font-normal text-default-900",
      }}
      {...props}
    >
      {items.map((item) => (
        <Tab key={item.key} title={item.title} />
      ))}
    </ExtendedTabs>
  );
};

Tabs.displayName = "RecareUI.Tabs";
